/* ============================================================
   Andes — Autoplay suave de los carruseles de colección del home.
   Usa la API nativa del slideshow-component de Horizon (next / select /
   atEnd), así respeta el snapping y las animaciones del tema.
   - Solo el carrusel EXTERIOR de cada product-list (no la galería de
     imágenes de cada tarjeta, ni carruseles deshabilitados).
   - Solo avanza cuando está EN pantalla (IntersectionObserver).
   - Pausa al pasar el mouse / tocar / enfocar dentro / pestaña oculta.
   - Respeta prefers-reduced-motion.
   ============================================================ */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var INTERVAL = 4500; // ms entre avances

  function initComp(comp) {
    if (comp.dataset.andesAutoplay) return;
    comp.dataset.andesAutoplay = '1';

    var paused = false;
    var inView = false;

    function tick() {
      if (paused || !inView) return;
      if (typeof comp.select !== 'function') return;
      var slides = comp.slides;
      var visible = comp.visibleSlides ? comp.visibleSlides.length : 1;
      if (!slides || slides.length <= (visible || 1)) return; // no desborda: nada que rotar
      if (comp.atEnd) comp.select(0); // volver al inicio
      else if (typeof comp.next === 'function') comp.next();
    }

    setInterval(tick, INTERVAL);

    function pause() { paused = true; }
    function resume() { paused = false; }
    comp.addEventListener('pointerenter', pause);
    comp.addEventListener('pointerleave', resume);
    comp.addEventListener('pointerdown', pause);
    comp.addEventListener('focusin', pause);
    comp.addEventListener('focusout', resume);
    document.addEventListener('visibilitychange', function () {
      paused = document.hidden;
    });

    var io = new IntersectionObserver(
      function (entries) { inView = entries[0].isIntersecting; },
      { threshold: 0.2 }
    );
    io.observe(comp);
  }

  function initAll() {
    var comps = document.querySelectorAll('[data-testid="product-list"] slideshow-component');
    for (var i = 0; i < comps.length; i++) {
      var c = comps[i];
      // Saltar la galería de imágenes interna de cada tarjeta y los carruseles
      // deshabilitados: solo el carrusel exterior de la fila de colección.
      if (c.closest('.card-gallery') || c.closest('.product-card')) continue;
      if (c.getAttribute('disabled') === 'true') continue;
      initComp(c);
    }
  }

  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', initAll);
  }
  window.addEventListener('load', initAll);
})();
